import React, { useState } from 'react';
import { relationshipsApi } from '../api';
import type { Person } from '../types/person';

interface RelationshipFormProps {
  people: Person[];
  onClose: () => void;
  onSubmit: () => void;
}

const RelationshipForm: React.FC<RelationshipFormProps> = ({ people, onClose, onSubmit }) => {
  const [person1Id, setPerson1Id] = useState<number>(0);
  const [person2Id, setPerson2Id] = useState<number>(0);
  const [relationshipType, setRelationshipType] = useState('朋友');
  const [description, setDescription] = useState('');
  const [strength, setStrength] = useState(5);
  const [loading, setLoading] = useState(false);

  const relationshipTypes = ['朋友', '同事', '家人', '敌人', '合作伙伴', '导师', '学生', '其他'];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!person1Id || !person2Id) {
      alert('请选择两个人物');
      return;
    }
    if (person1Id === person2Id) {
      alert('不能选择同一个人');
      return;
    }

    setLoading(true);
    try {
      await relationshipsApi.create({
        person1_id: person1Id,
        person2_id: person2Id,
        relationship_type: relationshipType,
        description: description || undefined,
        strength: strength,
      });
      onSubmit();
    } catch (error: any) {
      alert('创建关系失败: ' + (error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <div className="modal-header">
          <h2>添加人物关系</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>人物1 *</label>
            <select
              value={person1Id}
              onChange={(e) => setPerson1Id(Number(e.target.value))}
              required
            >
              <option value={0}>请选择</option>
              {people.map((person) => (
                <option key={person.id} value={person.id}>
                  {person.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>人物2 *</label>
            <select
              value={person2Id}
              onChange={(e) => setPerson2Id(Number(e.target.value))}
              required
            >
              <option value={0}>请选择</option>
              {people.map((person) => (
                <option key={person.id} value={person.id}>
                  {person.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>关系类型 *</label>
            <select
              value={relationshipType}
              onChange={(e) => setRelationshipType(e.target.value)}
              required
            >
              {relationshipTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>关系强度 (0-10)</label>
            <input
              type="range"
              min="0"
              max="10"
              step="0.5"
              value={strength}
              onChange={(e) => setStrength(Number(e.target.value))}
            />
            <span style={{ marginLeft: '10px' }}>{strength}</span>
          </div>

          <div className="form-group">
            <label>关系描述</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="描述这个关系的具体情况..."
              rows={3}
            />
          </div>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? '创建中...' : '创建关系'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RelationshipForm;

